import { Route } from '@angular/router';
import { AuthGuard } from '../auth/guards/auth.guard';
import { inject } from '@angular/core';
import { CsiRoutes } from './csi/csi-routes';
import { ContractRoutes } from '@/app/pages/contract/contracts-routes';
import { CropMapRoutes } from '@/app/pages/cropmap/cropmap-routes';
import { CropMapAdaptedRoutes } from '@/app/pages/cropmap-adapted/cropmap-routes';
import { ManualDataEntryRoutes } from '@/app/pages/manual-data-entry/manual-data-entry-routes';
import { OnsiteRoutes } from '@/app/pages/onsite/onsite-routes';
import { SustainabilityRoutes } from '@/app/pages/sustainability/sustainability-routes';
import { SurveyRoutes } from '@/app/pages/survey/survey-routes';
import { systemRoutes } from './system/system-pages.routes';
import { userRoutes } from './user/user-pages.routes';
import { inquiryRoutes } from './inquiry/inquiry-pages.routes';
import { ticketRoutes } from './ticket/ticket-pages.routes';
import { essentialsRoutes } from './essentials/essentials-pages.routes';
import { complianceRoutes } from './compliance/compliance-pages.routes';
import { satelliteRoutes } from './satellite/satellite-pages.routes';
import { assetRoutes } from './asset/asset-pages.routes';
import { companyRoutes } from './enterprise/enterprise-pages.routes';
import { deviceRoutes } from './device/device-pages.routes';
import { cropsRoutes } from './crop/crop-pages.routes';
import { purchaseRoutes } from './purchase/purchase-pages.routes';
import { contentHubRoutes } from './content/content-pages.routes';
import { notificationRoutes } from './notification/notification-pages.routes';
import { servicesRoutes } from './services/services-pages.routes';
import { fieldworkRoutes } from './fieldwork/fieldwork-pages.routes';
import { fertilizationRoutes } from './fertilization/fertilization-pages.routes';
import { marketRoutes } from './market/market-pages.routes';


export const pagesRoutes: Route = {
    path: '',
    loadComponent: () => import('./pages.component').then((m) => m.PagesComponent),
    canActivate: [() => inject(AuthGuard).canActivate()],
    children: [
        systemRoutes,
        ContractRoutes,
        CsiRoutes,
        CropMapRoutes,
        CropMapAdaptedRoutes,
        ManualDataEntryRoutes,
        SurveyRoutes,
        OnsiteRoutes,
        SustainabilityRoutes,
        userRoutes,
        inquiryRoutes,
        ticketRoutes,
        essentialsRoutes,
        complianceRoutes,
        satelliteRoutes,
        assetRoutes,
        companyRoutes,
        deviceRoutes,
        cropsRoutes,
        purchaseRoutes,
        contentHubRoutes,
        notificationRoutes,
        marketRoutes,
        servicesRoutes,
        fieldworkRoutes,
        fertilizationRoutes,
        {
            path: '**',
            redirectTo: 'user/users',
        },
    ],
};
